import HeroWidget from './HeroWidget';

export default HeroWidget;
